import { render, staticRenderFns } from "./ModalExchangeRate.vue?vue&type=template&id=28d176cf&scoped=true&"
import script from "./ModalExchangeRate.vue?vue&type=script&lang=js&"
export * from "./ModalExchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./ModalExchangeRate.vue?vue&type=style&index=0&id=28d176cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d176cf",
  null
  
)

export default component.exports